import { useAuthStore } from '@/stores/authStore';

/**
 * Reactive boolean: does the current user have the given permission?
 *
 * <p>Reads from {@code authStore.permissions} (a {@code Set<string>}) for O(1)
 * lookup. Subscribes to the store, so the component re-renders when the user's
 * permission set changes (e.g. after login, /me refresh, or logout).</p>
 *
 * <p>Use this for hiding UI affordances. Backend {@code @PreAuthorize} is the
 * source of truth -- this hook is for UI polish only.</p>
 */
export function useHasPermission(name: string): boolean {
  return useAuthStore((s) => s.permissions.has(name));
}
